import {AssessmentGroup} from "../../shared/models/assessment-group";

export class AssessmentGroupDisplay extends AssessmentGroup {
  Show:boolean;
  ShowAdd:boolean;
  constructor() {
    super();
    this.ShowAdd = false;
    this.Show = false;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/assessment-group-display.ts